var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.2865,
    height: 40.5365,
    rx: 9.57895,
    fill: "#C208E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7681 12.0183C25.7681 11.6536 25.9129 11.3039 26.1708 11.046C26.4287 10.7882 26.7784 10.6433 27.1431 10.6433H29.8931C30.2577 10.6433 30.6075 10.7882 30.8653 11.046C31.1232 11.3039 31.2681 11.6536 31.2681 12.0183V28.5183H31.9556C32.1379 28.5183 32.3128 28.5907 32.4417 28.7197C32.5706 28.8486 32.6431 29.0235 32.6431 29.2058C32.6431 29.3881 32.5706 29.563 32.4417 29.6919C32.3128 29.8209 32.1379 29.8933 31.9556 29.8933H11.3306C11.1482 29.8933 10.9734 29.8209 10.8444 29.6919C10.7155 29.563 10.6431 29.3881 10.6431 29.2058C10.6431 29.0235 10.7155 28.8486 10.8444 28.7197C10.9734 28.5907 11.1482 28.5183 11.3306 28.5183H12.0181V24.3933C12.0181 24.0286 12.1629 23.6789 12.4208 23.421C12.6787 23.1632 13.0284 23.0183 13.3931 23.0183H16.1431C16.5077 23.0183 16.8575 23.1632 17.1153 23.421C17.3732 23.6789 17.5181 24.0286 17.5181 24.3933V28.5183H18.8931V18.8933C18.8931 18.5286 19.0379 18.1789 19.2958 17.921C19.5537 17.6632 19.9034 17.5183 20.2681 17.5183H23.0181C23.3827 17.5183 23.7325 17.6632 23.9903 17.921C24.2482 18.1789 24.3931 18.5286 24.3931 18.8933V28.5183H25.7681V12.0183Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoIcon);
export default __webpack_public_path__ + "static/media/seo-icon.1ba865c520ad51caa5be7d593077d4c1.svg";
export { ForwardRef as ReactComponent };